import { normalizeSaveBeforeLeaveResult, type SaveBeforeLeaveResult } from "./saveBeforeLeaveOutcome";

export type UnsavedChangesGuardModalState = {
    isOpen: boolean;
    saving: boolean;
};

export type UnsavedChangesGuardModalAction =
    | { type: "open" }
    | { type: "dismiss" }
    | { type: "saveStart" }
    | { type: "saveEnd" };

export const initialUnsavedChangesGuardModalState: UnsavedChangesGuardModalState = {
    isOpen: false,
    saving: false,
};

export function shouldPromptBeforeProceed(isDirty: boolean): boolean {
    return isDirty;
}

export function unsavedChangesGuardModalReducer(
    state: UnsavedChangesGuardModalState,
    action: UnsavedChangesGuardModalAction
): UnsavedChangesGuardModalState {
    switch (action.type) {
        case "open":
            return { ...state, isOpen: true };
        case "dismiss":
            return { isOpen: false, saving: false };
        case "saveStart":
            return { ...state, saving: true };
        case "saveEnd":
            return { ...state, saving: false };
        default:
            return state;
    }
}

export type SaveAndContinueResult = "proceeded" | "stayed" | "validation_failed";

export const SAVE_AND_CONTINUE_VALIDATION_FAILED_TOAST =
    "Unable to save changes and continue. Please make sure you have provided the required values";

/** Orchestrates save-then-proceed for unit testing and hook reuse. */
export async function runSaveAndContinue(
    onSave: () => Promise<boolean | SaveBeforeLeaveResult>,
    proceed: () => void
): Promise<SaveAndContinueResult> {
    const outcome = normalizeSaveBeforeLeaveResult(await onSave());

    if (outcome === "validation_failed") {
        return "validation_failed";
    }

    if (outcome === "success") {
        proceed();
        return "proceeded";
    }

    return "stayed";
}
